export const skillsKeys = {
  root: ['skills'],
  skillCategories: (filters = {}) => [...skillsKeys.root, 'skillCategories', filters],
  skills: (filters = {}) => [...skillsKeys.root, 'skills', filters],
  contentSkills: ({ contentId, contentType }) => [...skillsKeys.root, 'contentSkills', contentId, contentType],
  librarySkills: ({ id, query = undefined, limit = undefined }) => [
    ...skillsKeys.root,
    'librarySkills',
    id,
    query,
    limit,
  ],
};

export enum SkillsMixpanelEvents {
  ADD_SKILL_CLICKED = 'admin_skills_drawer_add',
  CONTENT_OVERFLOW_CLICKED = 'admin_overview_page_skills',
  CONTENT_ADD_SKILL_CLICKED = 'admin_overview_page_skills_modal_add',
}
